import { Divider, Stack } from '@ltvco/refresh-lib/theme';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';

import {
  ChevronButton,
  TeaserAvatar,
  TeaserDetailLabel,
  TeaserDetailRow,
  TeaserDetailValue,
  TeaserInfo,
  TeaserItemContainer,
  TeaserItemRow,
  TeaserName,
} from '../components';
import { formatRelatives } from '../utils';

import type { AncestrySearchData } from 'components/DeepSearch/types';

interface AncestrySearchPreviewCardProps {
  data: AncestrySearchData;
  onTeaserClick?: (
    displayName: string,
    idType: string,
    idValue: string
  ) => void;
}

export const AncestrySearchPreviewCard = ({
  data,
  onTeaserClick,
}: AncestrySearchPreviewCardProps) => {
  if (!data.teasers.length) {
    return null;
  }

  return (
    <Stack divider={<Divider />}>
      {data.teasers.map((teaser, index) => (
        <TeaserItemContainer
          key={teaser.fsId || index}
          onClick={() => onTeaserClick?.(teaser.name, 'fs_id', teaser.fsId)}
        >
          <TeaserItemRow>
            <TeaserAvatar>
              <FamilyRestroomIcon fontSize="small" />
            </TeaserAvatar>
            <TeaserInfo>
              <TeaserName variant="body1">{teaser.name}</TeaserName>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Date of Birth:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.birthYear || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Date of Death:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.deathYear || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Locations:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {teaser.location || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
              <TeaserDetailRow>
                <TeaserDetailLabel variant="body2">
                  Relatives:
                </TeaserDetailLabel>
                <TeaserDetailValue variant="body2">
                  {formatRelatives(teaser.relatives) || '-'}
                </TeaserDetailValue>
              </TeaserDetailRow>
            </TeaserInfo>
            <ChevronButton>
              <ChevronRightIcon fontSize="small" />
            </ChevronButton>
          </TeaserItemRow>
        </TeaserItemContainer>
      ))}
    </Stack>
  );
};
